const controllerCartAction 		= new AbortController();
const signalCartAction 			= controllerCartAction.signal;
const controllerRenderSection 	= new AbortController();
const signalRenderSection 		= controllerRenderSection.signal;

var loadingSectionTimer = false;
var loadingSectionViewport = true;

const monthnamesArr = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
const salesChannelObj = {
  "morenutrition.de": {
    "name": "MORE",
    "color": '#0297b7'
  },
  "esn.com": {
    "name": "ESN (old)",
    "color": '#000000'
  },
  "esn3": {
    "name": "ESN",
    "color": '#000000'
  }
};

const tiktopPixel_1 = "C297DIFMU8Q03RAIET90";
const tiktopPixel_2	= "C4QVKVVM5GFN4SM702B0";
const pfandID		= 39789673742409; /*Variant ID from Default */
const tiktopPixel	= tiktopPixel_2;
var swiperSection	= {};
var toastTimeout;
var rootURL 	= "/";
function dgsSession(obj = {}, type = 'open', prop = '', cont){
  if(type == "open"){
    var dgsSession 		= sessionStorage.getItem('dgs_session')
    dgsSession 			= (dgsSession === null) ? "" : dgsSession;
    dgsSession 			= (dgsSession != "") ? JSON.parse(dgsSession) : {};
    return dgsSession;
  }else if(type == "read"){
    return obj['__'+prop] = ('__'+prop in obj) ? obj['__'+prop] : {};
  }else if(type == "push"){
    obj['__'+prop] = cont;
    return obj;
  }else if(type == "save"){ 
    sessionStorage.setItem('dgs_session',JSON.stringify(obj));
    //console.info(JSON.stringify(obj));
  }
}
function decodeLiquidData(encoded){
  var encoded	= parseFloat(encoded);
  var decoder1 	= parseInt(new Date().getFullYear());
  var decoder2 	= parseInt(new Date().getMonth()) + 1;
  return Math.round((encoded / decoder2) * decoder1);
}
function encodeLiquidData(decoded){
  var decoded	= parseFloat(decoded);
  var encoder1 	= parseInt(new Date().getFullYear());
  var encoder2 	= parseInt(new Date().getMonth()) + 1;
  return Math.round((decoded / encoder1) * encoder2);
}
function getCurrentRedirect(){
  var currentURL	 	= window.location.href;
  var uselessURL	  	= window.location.protocol + '//' + window.location.hostname;
  var currentRedirect 	= currentURL.replace(uselessURL,"");
  return currentRedirect;
}
//console.log(window.location);
function findGetParameter(parameterName,url = false){
  var result 	= null;
  var tmp 		= [];
  var search	= (url) ? ((url.includes("?")) ? "?"+(url.split("?"))[1] : "") : location.search.substr(1);
  var search	= (typeof search === "undefined") ? "" : search;
  var items 	= search.split("&");
  for(var index = 0; index < items.length; index++){
    tmp = items[index].split("=");
    if(tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
}
function configURL(result = "return",type = "add",key = "view",value = "",url = false){
  var currentURL 	= (url) ? url : window.location.href;
  var search 		= (url) ? ((url.includes("?")) ? "?"+(url.split("?"))[1] : "") : (window.location.search).toString();
  var oldurl 		= currentURL;
  var newurl 		= currentURL;
  //console.log(url,currentURL);
  var first 	= (oldurl.includes("?"+key) || search == "") ? true : false;
  var parameter = findGetParameter(key,currentURL);
  //console.log(parameter,first);
  if(type == "remove"){      
    if(parameter){
      var query = key+"="+parameter;
      var target = (first) ? "?"+query : "&"+query;
      //console.log(oldurl,target);
      newurl = oldurl.replace(target,"");
      //console.log(newurl);
    }
  }else if(type == "add" && parameter !== null){
    var oldQuery = key+"="+parameter;
    var oldTarget = (first) ? "?"+oldQuery : "&"+oldQuery;
    var newQuery = key+"="+value;
    var newTarget = (first) ? "?"+newQuery : "&"+newQuery;
    newurl = oldurl.replace(oldTarget,newTarget);
  }else if(type == "add"){
    var newQuery = key+"="+value;
    var first 	= (oldurl.includes("?")) ? true : false;
    var newTarget = (!first) ? "?"+newQuery : "&"+newQuery;
    newurl = oldurl+newTarget;
  }
  var count_con1 = (newurl.match(/\?/g) || []).length;
  var count_con2 = (newurl.match(/\&/g) || []).length;
  if(parseInt(count_con1) == 0 && parseInt(count_con2) >= 1){
    newurl = newurl.replace("&","?");
  }
  if(result == "change"){
    window.history.replaceState({}, null, newurl);
  }else if(result == "reload"){
    window.location.href = newurl;
  }else{ return newurl; }
}
$.fn.isFullInViewport = function() {
  var headerTop			= Math.abs(parseInt(($("header").css("top")).replace("px","")));
  var headerHeight		= Math.abs(parseInt($("header").innerHeight()));
  var distanceTop		= ($(window).scrollTop() >= headerTop) ? headerHeight - headerTop : headerHeight;
  var elementTop 		= $(this).offset().top;
  var elementBottom 	= elementTop + $(this).outerHeight();
  var viewportTop 		= distanceTop + $(window).scrollTop();
  var viewportBottom 	= viewportTop + ($(window).height());
  return elementTop > viewportTop && elementBottom <= viewportBottom;
};
$.fn.isInViewport = function() {
  var headerTop			= Math.abs(parseInt(($("header").css("top")).replace("px","")));
  var headerHeight		= Math.abs(parseInt($("header").innerHeight()));
  var distanceTop		= ($(window).scrollTop() >= headerTop) ? headerHeight - headerTop : headerHeight;
  var elementHeight 	= $(this).outerHeight();
  var elementTop 		= $(this).offset().top;
  var elementBottom 	= elementTop + elementHeight;
  if($(this).attr("dgs-viewport") == "false"){
    var factor 			= $(this).attr("data-factor");
    var factor			= (factor == "" || typeof factor === "undefined") ? 0 : parseFloat(factor);
    var elementTop 		= elementTop + ($(window).height() * factor);
  }
  var viewportTop 		= ($(window).scrollTop() >= distanceTop) ? ($(window).scrollTop() + distanceTop) : $(window).scrollTop();
  var viewportBottom 	= $(window).scrollTop() + ($(window).height() + 0);
  return elementTop < viewportBottom;
};
function checkViewport(){
  $('*[dgs-viewport]').not("[dgs-auto='false']").each(function(){
    if($(this).isInViewport()){
      $(this).attr("dgs-viewport","true");
    }else{
      $(this).attr("dgs-viewport","false");
    }
  });
}
function sectionLoadingFailed(section,target,status){

}
function renderSectionQuery(fetchURL,key,value){
  return fetchURL+"&"+key+"="+value;
}
function renderSectionAsync(target,section,root = "/",query = {}){
  if(typeof loadingSectionTimer !== "undefined"){clearTimeout(loadingSectionTimer);}
  var fetchURL = root;
  var timestamp = new Date().getTime();
  if(query.hasOwnProperty('tagged') && query.tagged != ""){ fetchURL = fetchURL+'/tagged/'+query.tagged; }
  fetchURL = fetchURL+'?sections='+section;
  if(query.hasOwnProperty('page') && query.page != ""){ fetchURL = renderSectionQuery(fetchURL,"page",query.page); }
  if(query.hasOwnProperty('sort_by') && query.sort_by != ""){ fetchURL = renderSectionQuery(fetchURL,"sort_by",query.sort_by); }
  if(query.hasOwnProperty('brands') && query.brands != ""){ fetchURL = renderSectionQuery(fetchURL,"brands",query.brands); }
  if(query.hasOwnProperty('variant') && query.variant != ""){ fetchURL = renderSectionQuery(fetchURL,"variant",query.variant); }
  if(query.hasOwnProperty('type') && query.type != ""){ fetchURL = renderSectionQuery(fetchURL,"type",query.type); }
  if(query.hasOwnProperty('tags') && query.tags != ""){ fetchURL = renderSectionQuery(fetchURL,"tags",query.tags); }
  if(query.hasOwnProperty('q') && query.q != ""){ fetchURL = renderSectionQuery(fetchURL,"q",query.q); }
  var getParameter_view	= findGetParameter("view");
  if(query.hasOwnProperty('view') && query.view != ""){ fetchURL = renderSectionQuery(fetchURL,"view",query.view); }
  else if(getParameter_view !== null){ fetchURL = renderSectionQuery(fetchURL,"view",getParameter_view); }
  var getParameter_show	= findGetParameter("show");
  if(getParameter_show !== null){ fetchURL = renderSectionQuery(fetchURL,"show",getParameter_show); }
  var getParameter_hide	= findGetParameter("hide");
  if(getParameter_hide !== null){ fetchURL = renderSectionQuery(fetchURL,"hide",getParameter_hide); }
  if(section == "dgs-product-quotes"){ fetchURL = fetchURL + "&"+timestamp; }
  console.log("fetchURL",fetchURL);
  fetch(fetchURL, {cache: "no-cache",signalRenderSection}).then(function(response){
    //console.log(response);
    if(!response.ok){ sectionLoadingFailed(section,target,response.status); }
    return response.text();
  }).then(function(response) {
    var response = JSON.parse(response);
    //console.log((response[section]).html());
    $("#"+target).attr("import","");
    if(target.includes("page")){
      $("#"+target).replaceWith(response[section]).promise().done(function() {
        checkViewport(); checkImgLoader();
        $("#"+target).removeAttr("import")
        .removeAttr("secloader").removeAttr("loading")
        .attr("loaded","");
        loadingSectionViewport = true;
      });
    }else{
      $("#"+target).html(response[section]).promise().done(function() {
        checkViewport(); checkImgLoader();
        $("#"+target).removeAttr("import")
        .removeAttr("secloader").removeAttr("loading")
        .attr("loaded","");
        loadingSectionViewport = true;
      });
    }
  }).catch(function(error){
    sectionLoadingFailed(section,target,error.status);
  });
}
function initialSectionAsync(target,section,root = "/",query = {}){
  if($("#"+target).length){
    if($("#"+target).isInViewport() && loadingSectionViewport){
      if(typeof loadingSectionTimer !== "undefined"){clearTimeout(loadingSectionTimer);}
      renderSectionAsync(target,section,root,query);
    }else{      
      var prerender = rootURL+'?sections='+section;
      //console.log(!!($("head").find("link[rel='prerender'][data-section='"+section+"']")).length);
      if(!!($("head").find("link[rel='prerender'][data-section='"+section+"']")).length == false){
        $("head").append('<link rel="prerender" data-section="'+section+'" href="'+prerender+'">');
      }
      var sectionConfig = {'target':target,'section':section,'root':root,'query':query};
      $("#"+target).attr("secloader",JSON.stringify(sectionConfig)).attr("dgs-viewport","");
    }
  }
}
function setCountryCode(){
  var returnCountryCode = "DE";
  var ipinfoApiKey 		= "BciKmHK7vwMEM4b";  
  $.ajax({
    type:'GET', async:false, dataType: 'json',
    url:'https://pro.ip-api.com/json?key='+ipinfoApiKey+'&fields=status,message,countryCode',     
    success: function(response){
      //var countryCode 		= (response.countryCode).toUpperCase();
        var countryCode 		= response.countryCode;
      //console.log("write",countryCode);
      sessionStorage.setItem("countryCode",countryCode);
      returnCountryCode 		= countryCode;
    }
  });
  return returnCountryCode;
}
function checkSectionAsync(){
  if($('*[secloader]:not([loading])').length){
    $('*[secloader]:not([loading])').each(function(){
      var target = $(this).attr("id");
      //console.log("scroll",target);
      if($("#"+target).isInViewport()){
        $("#"+target).attr("loading","");
        var secloader = $("#"+target).attr("secloader");
        if(typeof secloader !== 'undefined' && secloader !== false) {
          var sc = JSON.parse(secloader);
          //console.log("render",sc);
          renderSectionAsync(sc.target,sc.section,sc.root,sc.query);
        }
      }
    });
  }
}
function filterCollection(target,handle,query,skeleton = 1){
  //console.log("query",query);
  $("html, body").animate({ scrollTop: 0 }, 500);
  $("div[list-counter='"+handle+"']").text("-");
  if(skeleton == 1){
    $(".dgs-collection-noresult").attr("show",0);
    var tempSkeleton = $("#lazyload-"+target).attr("temp-skeleton");
    $("#lazyload-"+target).html(atob(tempSkeleton));
  }else{ $("div[list-table='"+handle+"']").attr("update","1"); }
  var collectionPath = window.Shopify.routes.root + "collections/"+handle;
  renderSectionAsync("lazyload-"+target,target,collectionPath,query);
}
function hasNumber(str){ return /\d/.test(str); }
document.addEventListener("DOMContentLoaded", function(event) {
  //document.body.setAttribute("loaded","");
});